import teky from "../assets/Teky.webp";
import ivg from "../assets/IVG.png";
export const experiences = [
  {
    id: 1,
    role: "Part-time Lecturer",
    company: "Teky Academy",
    year: "2024 - Present",
    desc: "Teaching programming and robotics competition prep.",
    img: teky,
  },
  {
    id: 1,
    role: "Front-End Developer Internship",
    company: "IVG Vietnam",
    year: "3/2025 - 9/2025",
    desc: "Assisted with front-end tasks: UI adjustments, testing, and code updates under team guidance.",
    img: ivg,
  },
];
